import {
    LOAD_LOCATION_TITLE,
    UPDATE_LOCATION_TITLE,
    HIDE_MENU,
    SCROLL_CHANGE,
    SET_DEBUGGING,
    SET_TRANSPARENT_FOOTER,
    SET_IS_EXTRANET_APP,
    SET_PAGE_SIZE,
    SET_PAGE_NUMBER,
    DEFAULT_PAGE_SIZE,
    SET_NB_TOTAL_RESULTS,
    SET_ORDER_BY,
    SET_DESC_ORDER,
} from "./contextInfosConstants";
import { setValue } from "../../lib/immutable_wrapper";
import { getDefaultTotalResults } from "./contextInfosActions";

const initialState = {
    hideMenu: false,
    transparentFooter: false,
};

const initialStateContext = {
    scrollY: 0,
    debugging: false,
    isExtranetApp: false,
};

const initialTableState = {
    pageSize: DEFAULT_PAGE_SIZE,
    pageNumber: 0,
    nbTotalResults: getDefaultTotalResults(),
    orderBy: "",
    descOrder: false,
};

export default function (state, { type, payload }) {
    switch (type) {
        case LOAD_LOCATION_TITLE: {
            return { locationTitle: state.locationTitle };
        }
        case UPDATE_LOCATION_TITLE: {
            return { locationTitle: payload };
        }
        default:
            return state;
    }
}

export function locationTitle(state = [], action) {
    switch (action.type) {
        case LOAD_LOCATION_TITLE:
            if (!action.payload.locationTitle) {
                return state;
            }
            return action.payload.locationTitle;
        case UPDATE_LOCATION_TITLE:
            if (!action.payload.locationTitle) {
                return state;
            }
            return action.payload.locationTitle;
        default:
            return state;
    }
}

export function context(state = initialStateContext, action) {
    switch (action.type) {
        case SCROLL_CHANGE:
            return setValue(state, ["scrollY"], action.scrollY);
        case SET_DEBUGGING:
            return setValue(state, ["debugging"], action.debugging);
        case SET_IS_EXTRANET_APP:
            return setValue(state, ["isExtranetApp"], action.isExtranetApp);
        default:
            return state;
    }
}

export function layout(state = initialState, action) {
    switch (action.type) {
        case HIDE_MENU:
            return setValue(state, ["hideMenu"], action.hideMenu);
        case SET_TRANSPARENT_FOOTER:
            return setValue(state, ["transparentFooter"], action.transparentFooter);
        default:
            return state;
    }
}

export function tableState(state = initialTableState, action) {
    switch (action.type) {
        case SET_PAGE_SIZE:
            return setValue(state, ["pageSize"], action.pageSize);
        case SET_PAGE_NUMBER:
            return setValue(state, ["pageNumber"], action.pageNumber);
        case SET_NB_TOTAL_RESULTS:
            return setValue(state, ["nbTotalResults"], action.nbTotalResults);
        case SET_ORDER_BY:
            return setValue(state, ["orderBy"], action.orderBy);
        case SET_DESC_ORDER:
            return setValue(state, ["descOrder"], action.descOrder);
        default:
            return state;
    }
}
